import * as API from "../../api";
import * as actionType from '../action-types/migration';

import { message } from "antd";
import {
    setLoadingSubmit,
    unsetLoadingSubmit,
} from './style';

export const get_stages = (uids) => (dispatch) => {
    dispatch(setLoadingSubmit());

    API.getAllUserStages(uids)
        .then(data => {
            if (data && data.status && data.status === 200) {
                dispatch(get_stage_success(data.users));

                dispatch(unsetLoadingSubmit());
            } else {
                message.error(data.err || `Error getting users`);

                dispatch(unsetLoadingSubmit());
            }
        })
}

const get_stage_success = (users) => {
    // console.log("get_stage_success data:", data);

    return {
        type: actionType.GET_STAGES,
        users
    }
}

export const migrate_user = (uid, sourceStage, targetStage) => (dispatch) => {
    dispatch(setLoadingSubmit());
    message.loading('Migrating user...')
    API.migrateUser(uid, sourceStage, targetStage)
        .then(data => {
            // console.log("migrate_user data:", data);

            if (data.status !== 200) {
                message.error(data.err || `Error migrating user`);

                dispatch(unsetLoadingSubmit());
            }
            else {
                message.success('Succesfully migrated user')
                const migratedAt = data.user.createdAt
                dispatch(migrate_user_success(uid, targetStage, migratedAt));

                dispatch(unsetLoadingSubmit());
            }
        })
}

const migrate_user_success = (uid, targetStage, migratedAt) => {
    // console.log("migrate_user_success data:", data);

    return {
        type: actionType.MIGRATE_USER,
        uid,
        targetStage,
        migratedAt,
    }
}

export const set_user_to_migrate = (selectedUser) => {
    // console.log("set_user_to_migrate data:", data);

    return {
        type: actionType.SET_USER_TO_MIGRATE,
        selectedUser: selectedUser,
    }
}